import { render, staticRenderFns } from "./newetransport.vue?vue&type=template&id=1a8e6c96&scoped=true"
import script from "./newetransport.vue?vue&type=script&lang=js"
export * from "./newetransport.vue?vue&type=script&lang=js"
import style0 from "./newetransport.vue?vue&type=style&index=0&id=1a8e6c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8e6c96",
  null
  
)

export default component.exports